import { useEffect, useState } from 'react';
import axios from 'axios';
import { useMenuStore } from '../zustand/store/useMenuStore';
import { useShallow } from 'zustand/shallow';
import useQueryLinkNavigate from '../hooks/useQueryLinkNavigate';
import { useModalOpen } from '../hooks/useToastModalOpen';
import { useSubIcon } from '../hooks/useSubIcon';
import useConfirm from '../hooks/useConfirm';
import useModalStore from '../zustand/store/useModalStore';
import MyPage from '../contents/member/mypage/MyPage';
import ToastModal from './common/modal/ToastModal';

import { useDynamicStyle } from '../hooks/useDynamicStyle';
import '../css/main.css'
import '../css/side-bar.css'

const Main = ({ children }) => {

    const { isHome } = useQueryLinkNavigate();
    const [overYn, setOverYn] = useState(localStorage.getItem('overYn'));

    // favorite menu function
    const favMenuData = useMenuStore(state => state.favMenuData);

    // menu info
    const [ menuData, mainSubTitle, clickedCategory, favoriteMenuData ] = useMenuStore(useShallow(
        (state) => [state.menuData, state.mainSubTitle, state.clickedCategory, state.favoriteMenuData]));
    const { mainTitle, checkedTopCode, checkedMenuFlag } = useMenuStore(state => state.currentInfo);
    
    // modal open function
    const { toastModalOpen } = useModalOpen();
    const [ toastState, mypageModal, setMypageModal ] = useModalStore(
        useShallow((state) => [state.toastState, state.mypageModal, state.setMypageModal]));

    // confirm hook
    const confirm = useConfirm();

    // 현재 페이지 즐겨찾기 여부 확인
    let favList = [];
    for (let i = 0; i < favoriteMenuData?.length; i++) {
        favList.push(favoriteMenuData[i].MENUFLAG);
    }
    const favoriteMenu = favList.includes(checkedMenuFlag);

    const favMenuHandler = async (title, category, menuflag, favoriteMenu) => {
        try {
            if (favoriteMenu) {
                const ok = await confirm("즐겨찾기에서 '" + title + "' 메뉴를 삭제하시겠습니까?");
                if (!ok) return false;

                await axios.delete('/ptmiapi/deleteFavoriteMenu.do', {
                    data: { symnidno: Number(category), menuflag: String(menuflag) }
                });
                toastModalOpen('즐겨찾기에서 메뉴가 삭제되었습니다.');
                favMenuData();
            } else {
                const ok = await confirm("즐겨찾기에 '" + title + "' 메뉴를 추가하시겠습니까?");
                if (!ok) return false;

                await axios.post('/ptmiapi/insertFavoriteMenu.do', {
                    symnidno: Number(category), menuflag: String(menuflag)
                });
                toastModalOpen('즐겨찾기에 메뉴가 추가되었습니다.');
                favMenuData();
            }
        } catch (error) {
            console.error('즐겨찾기 메뉴 추가/삭제 중 오류 발생:', error);
        }
    };

    // Dynamic Style Hook
    const { fontColor, darkBackColor, lightBorderShadowColor } = useDynamicStyle();

    // icon list
    const { favIcon, hoverFavIcon, favFullIcon, hoverFavFullIcon } = useSubIcon();

    // 상위 메뉴 매칭 아이콘
    const topMenu = menuData[clickedCategory] || [];
    const subMenu = topMenu?.menuTree;
    const { primarySubIcon } = useSubIcon();
    const mainIcons = subMenu && subMenu?.map((menu, idx) => ({ [menu.MENUFLAG]: primarySubIcon[idx] }));
    const icon = mainIcons && mainIcons.reduce((acc, obj) => {
        if (checkedTopCode !== 0 && obj[checkedTopCode] !== undefined) {
            return obj[checkedTopCode];
        } else if (checkedTopCode === 0 && obj[checkedMenuFlag] !== undefined) {
            return obj[checkedMenuFlag];
        }
        return acc;
    }, undefined);

    const top_menu = clickedCategory === 3 ? 'st' : clickedCategory === 21 ? 'tr' : 'ho';

    // esc 키 누르면 모달 닫히는 기능
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                setMypageModal(false);
            }
        };

        // 이벤트 리스너 등록
        document.addEventListener('keydown', handleEscape);

        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [mypageModal]);

    return (
        <div className='responsive_container min-w-0'>
            <div className={`main_active ${top_menu} ${lightBorderShadowColor}`} style={{ backgroundColor: isHome ? '' : 'white', border: isHome ? 'none' : '', boxShadow: isHome ? 'none' : '', padding: isHome ? '0' : '' }}>
                {!mypageModal && (overYn === 'N' || overYn === null) ? '' : <MyPage overYn={overYn} setOverYn={setOverYn} />}
                {!toastState ? '' : <ToastModal />}
                <div className='h-full flex flex-col'>
                    {isHome ? '' :
                        <div className='main_title_wrapper'>
                            <h4 className={`main_title ${fontColor}`}>{icon}&nbsp;{mainTitle && mainTitle}{mainSubTitle && mainSubTitle}</h4>
                            <button className={`relative cursor-pointer h_icon_box tooltip_box`}
                                onClick={() => favMenuHandler(mainTitle, clickedCategory, checkedMenuFlag, favoriteMenu)}>
                                {favoriteMenu ?
                                    <>
                                        <div className='icon'>{favFullIcon}</div>
                                        <div className='hover_icon'>{hoverFavFullIcon}</div>
                                    </>
                                    :
                                    <>
                                        <div className='icon'>{favIcon}</div>
                                        <div className='hover_icon'>{hoverFavIcon}</div>
                                    </>
                                }
                                <span className={`tooltip main_fav_tool_position ${darkBackColor}`}>{favoriteMenu ? '즐겨찾기 삭제' : '즐겨찾기 추가'}</span>
                            </button>
                        </div>
                    }
                    <div className='flex flex-col flex-grow min-h-0'>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;

